import { UpdateEmail } from "@Light/components/account/Details/UpdateEmail";
import { UpdateName } from "@Light/components/account/Details/UpdateName";
import { QueryLoader } from "@Light/components/app/QueryLoader";
import { RequireNoService } from "@Light/components/app/RequireNoService";
import { RequireService } from "@Light/components/app/RequireService";
import { Vertical } from "@Light/components/enroll/common/Vertical";
import { ServiceCard } from "@Light/components/enroll/ServiceCard";
import { CircleIcon } from "@Light/components/page/CircleIcon";
import { Container } from "@Light/components/page/Container";
import { DetailField } from "@Light/components/page/detail/DetailField";
import { DetailLabel } from "@Light/components/page/detail/DetailLabel";
import { ESIIDField } from "@Light/components/page/detail/ESIIDField";
import { ServiceAddressField } from "@Light/components/page/detail/ServiceAddressField";
import { Divided } from "@Light/components/page/Divided";
import { EnumeratedList } from "@Light/components/page/EnumeratedList";
import { Header } from "@Light/components/page/header";
import { HeaderPopover } from "@Light/components/page/header/HeaderPopover";
import { BaseMenu } from "@Light/components/page/header/menu/BaseMenu";
import { EnrollmentMenu } from "@Light/components/page/header/menu/EnrollmentMenu";
import { LogoutButton } from "@Light/components/page/header/menu/LogoutButton";
import { Menu } from "@Light/components/page/header/menu/Menu";
import { MenuHeader } from "@Light/components/page/header/menu/MenuHeader";
import { MenuItem } from "@Light/components/page/header/menu/MenuItem";
import { PendingServiceMenu } from "@Light/components/page/header/menu/PendingServiceMenu";
import { ServiceMenu } from "@Light/components/page/header/menu/ServiceMenu";
import { Hyperlink } from "@Light/components/page/Hyperlink";
import { InfoItem } from "@Light/components/page/InfoItem";
import { Overlay } from "@Light/components/page/Overlay";
import { PageBody } from "@Light/components/page/PageBody";
import { ProgressBar } from "@Light/components/page/ProgressBar";
import { Subtitle } from "@Light/components/page/Subtitle";
import { Title } from "@Light/components/page/Title";
import { Datepicker } from "@Light/components/system/Datepicker";
import {
  Description,
  ErrorMessage,
  Field,
  FieldGroup,
  Fieldset,
  Label,
  Legend,
} from "@Light/components/system/Fieldset";
import { Input, Select } from "@Light/components/system/Input";
import { Link } from "@Light/components/system/Link";
import { MobileNavLink } from "@Light/components/system/MobileNavLink";
import { Spinner } from "@Light/components/system/Spinner";
import { BrandMode } from "@Light/services/lightTypes";
import { Navigate } from "react-router-dom";

export const defaultScaffold = {
  page: {
    companyName: "ACME",
    brandMode: BrandMode.Featured,
    supportEmail: "support@light.dev",
    supportPhone: "800-956-6208",
    supportHours: "",
    colors: {
      text: {
        primary: "text-[#101828]",
        secondary: "text-[#344054]",
        tertiary: "text-[#475467]",
        muted: "text-[#667085]",
        mutedHover: "hover:text-[#344054]",
        label: "text-[#414651]",
        successStrong: "text-[#087443]",
        indigo: "text-[#363F72]",
        info: "text-blue-600",
        warn: "text-orange-600",
        error: "text-red-700",
        link: "text-slate-900",
        button: "text-slate-600 hover:text-slate-900",
        success: "text-green-600",
      },
      button: {
        background: {
          plain: "bg-[#101828] hover:bg-[#667085]",
          plainDisabled: "bg-[#667085]",
          error: "bg-[#D92D20] hover:bg-[#F97066]",
          errorDisabled: "bg-[#F97066]",
        },
        info: "bg-blue-600 hover:bg-blue-500",
      },
      border: {
        paper: "border-white",
        plain: "border-[#EAECF0]",
        subtle: "border-[#e9eaeb]",
        indigo: "border-[#D5D9EB]",
        info: "border-blue-600",
        warn: "border-orange-600",
        error: "border-red-600",
        success: "border-green-600",
      },
      background: {
        subtle: "bg-[#F8F9FC]",
        successSubtle: "bg-[#edfcf2]",
        info: "bg-blue-50",
        warn: "bg-orange-50",
        error: "bg-red-50",
        success: "bg-[#ECFDF3]",
      },
      hover: {
        highlight: "hover:bg-slate-100",
      },
      chart: {
        primary: "#98C9FF",
        secondary: "#3E83E8",
        unselected: "#CBD1DB",
      },
    },
    overlay: Overlay,
    title: Title,
    subtitle: Subtitle,
    hyperlink: Hyperlink,
    container: Container,
    divided: Divided,
    header: {
      header: Header,
      defaultRightButton: HeaderPopover,
      menu: {
        menu: Menu,
        serviceMenu: ServiceMenu,
        pendingServiceMenu: PendingServiceMenu,
        enrollmentMenu: EnrollmentMenu,
        baseMenu: BaseMenu,
        menuHeader: MenuHeader,
        menuItem: MenuItem,
        logoutButton: LogoutButton,
      },
    },
    pageBody: PageBody,
    progressBar: ProgressBar,
    detail: {
      detailLabel: DetailLabel,
      detailField: DetailField,
      esiidField: ESIIDField,
      serviceAddressField: ServiceAddressField,
    },
    circleIcon: CircleIcon,
    enumeratedList: EnumeratedList,
    infoItem: InfoItem,
  },
  app: {
    queryLoader: QueryLoader,
    requireNoService: RequireNoService,
    requireService: RequireService,
  },
  system: {
    fieldset: Fieldset,
    legend: Legend,
    fieldGroup: FieldGroup,
    field: Field,
    label: Label,
    description: Description,
    errorMessage: ErrorMessage,
    input: Input,
    select: Select,
    spinner: Spinner,
    link: Link,
    mobileNavLink: MobileNavLink,
    datepicker: Datepicker,
    navigate: Navigate,
  },
  enroll: {
    serviceCard: ServiceCard,
    common: {
      vertical: Vertical,
    },
  },
  dash: {},
  account: {
    details: {
      updateName: UpdateName,
      updateEmail: UpdateEmail,
    },
  },
};
